import React from "react";

const TONE_CLASSES = {
  pending: "bg-glow-mid/10 text-glow-mid border-glow-mid/30",
  healthy: "bg-success/10 text-success border-success/30",
  warning: "bg-warning/10 text-warning border-warning/30",
  danger: "bg-danger/10 text-danger border-danger/30",
  neutral: "bg-surface/60 text-celestial-muted border-celestial-border/30",
  info: "bg-glow-light/10 text-glow-light border-glow-light/30",
};

// Friendly default label/tone mapping for common status strings, so callers
// can just pass `status="open"` etc. without picking a tone every time.
const STATUS_PRESETS = {
  open: "danger",
  investigating: "warning",
  resolved: "healthy",
  pending: "pending",
  dismissed: "neutral",
  active: "healthy",
  draft: "neutral",
  scheduled: "info",
  archived: "neutral",
  "needs review": "warning",
  updated: "healthy",
};

const StatusBadge = ({ status, tone, children, className = "" }) => {
  const resolvedTone = tone || STATUS_PRESETS[(status || "").toLowerCase()] || "neutral";
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-medium px-2 py-0.5 rounded-full border capitalize ${TONE_CLASSES[resolvedTone]} ${className}`}
    >
      {children || status}
    </span>
  );
};

export default StatusBadge;
